// extracted by mini-css-extract-plugin
export default {"emptyStateDivBox":"emptyStateDivBox__BgvEW","melcloudListBody":"melcloudListBody__1YEd5"};